module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-10 table-container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.x_axis) ? _c('div', [_c('el-tag', {
          staticClass: "m-l-10",
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.x_axis))])]) : (scope.row.series) ? _c('div', [_c('el-tag', {
          staticClass: "m-l-10",
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.series))])]) : (scope.row.y_axis) ? _c('div', [_c('el-tag', {
          staticClass: "m-l-10",
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.y_axis))])]) : _vm._e(), _vm._v(" "), _vm._v(" ")]
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-005d91b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/chartTables/barChartTable.vue
// module id = 1752
// module chunks = 2